import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import auth from '@react-native-firebase/auth';
import { Text, View, StyleSheet, Platform, ScrollView } from 'react-native';
import { Field, reduxForm } from 'redux-form';
import { UserServiceClient } from 'fitbeat.api-clients';
import { Button, showMessage, TextInput, isEmailValid } from 'fitbeat.react-native-components';
import { getApiConfig } from '../config/index';
import { GoogleAnalytics } from '../services/google-analytics';
import { isMobileWeb } from './SignupFormsStyles';
import { defaultScale } from '../utils/scaling';
import { addDeepLinkParams } from '../utils/notifications/actions';
import StudioUserExistsError from './components/StudioUserExistsError';
import Theme from '../theme';


class ForgotPassword extends Component {
  googleAnalytics = new GoogleAnalytics();
  unAuthenticatedUserServiceClient = new UserServiceClient(getApiConfig(), fetch, console.log, undefined);

  state = {
    isLoading: false,
    studioAccountAlreadyExists: false,
  };

  componentDidMount = () => {
    this.googleAnalytics.setCurrentScreen('ForgotPassword');
  }

  onSubmit = async (values) => {
    const { email } = values;
    const { t, addToDeepLinkParams } = this.props;
    this.setState({ isLoading: true });

    const preSignupAccountWithEmail = await this.unAuthenticatedUserServiceClient.getUserForPreAccountByEmail(
      values.email);
    const isExisitingUserWithPreToken = preSignupAccountWithEmail && preSignupAccountWithEmail.continueSignupToken;
    if (isExisitingUserWithPreToken) {
      this.setState({
        studioAccountAlreadyExists: true,
        isLoading: false,
        continueSignupToken: preSignupAccountWithEmail.continueSignupToken,
      });
      return;
    }

    const getOtherSignInProviders = async () => {
      try {
        const signInMethods = await auth().fetchSignInMethodsForEmail(email);
        if (signInMethods.indexOf('password') !== -1) {
          // user has password also, so allow
          return null;
        }

        return signInMethods
          .map((p) => {
            if (p === 'google.com') {
              return 'Google';
            } else if (p === 'facebook.com') {
              return 'Facebook';
            }
          })
          .filter((p) => p !== undefined);
      } catch (e) {
        // silently ignored
      }

      return null;
    };

    const provider = await getOtherSignInProviders();
    if (provider && provider.length > 0) {
      const accountList = provider.join(' or ');
      showMessage(t('resetErrorUseSocialSignIn', { accountList }));
      this.setState({ isLoading: false });
      return;
    }

    try {
      await auth().sendPasswordResetEmail(email);
    } catch (e) {
      // silently ignored
    } finally {
      // Always show successful for security reasons
      showMessage(t('youWillRecieveInstructions'));
      this.setState({ isLoading: false });
      console.log(this.props.navigation);
      this.props.navigation.goBack();
    }
  }

  login = () => {
    this.props.navigation.navigate('Login');
  }

  render() {
    const {
      t,
      handleSubmit,
      navigation
    } = this.props;
    const { isLoading, studioAccountAlreadyExists, continueSignupToken } = this.state;
    return (
      <View style={styles.container}>
        <ScrollView
          scrollEnabled={false}
          contentContainerStyle={styles.contentContainerStyle}
          keyboardShouldPersistTaps="handled">

          <Field
            forwardRef
            autoFocus
            name="email"
            placeholder={t('formFields:email')}
            returnKeyType="next"
            autoCapitalize="none"
            component={TextInput}
            validate={isEmailValid}
            keyboardType="email-address"
            ref={(ref) => { this.emailInput = ref; }}
            onSubmitEditing={handleSubmit(this.onSubmit)}
          />

          <Button
            fontColor={Theme.WHITE}
            isLoading={isLoading}
            containerStyle={{ marginTop: 3 }}
            onPress={handleSubmit(this.onSubmit)}
            title={t('resetPassword')}
            overrideFontStyles={{ fontFamily: Theme.Custom800 }}
          />

          {Platform.OS === 'web' &&
            <Text
              onPress={this.login}
              style={styles.loginText}>
              {t('login')}
            </Text>
          }
          {studioAccountAlreadyExists && continueSignupToken &&
            <StudioUserExistsError t={t} navigation={navigation} continueSignupToken={continueSignupToken} />
          }
        </ScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 15,
    paddingTop: isMobileWeb ? defaultScale(48) : 0,
    backgroundColor: Theme.WHITE,
  },
  contentContainerStyle: {
    flexGrow: 1,
    paddingTop: 15,
  },
  loginText: {
    fontSize: 14,
    fontFamily:Theme.CustomBold,
    textAlign: 'right',
    paddingVertical: 5,
    color: Theme.PRIMARY,
  },
});

const mapDispatchToProps = (dispatch) => {
  return {
    addToDeepLinkParams : (params) => dispatch(addDeepLinkParams(params))
  }
}

ForgotPassword = translate(['auth', 'formFields'], { wait: true })(ForgotPassword);
ForgotPassword = connect(null, mapDispatchToProps)(reduxForm({ form: 'ForgotPasswordForm' })(ForgotPassword));
export default ForgotPassword;
